import bearing from "@turf/bearing";
import { Feature, LineString } from "geojson";

import { FilterConfiguration, SublayerConfig } from "fond/types/ProjectLayerConfig";

// For FilterConfigurations that have not set a filter we show all features
// This blank filter will match all features
const BLANK_FILTER = ["!", false];

/**
 * Builds a Mapbox filter based on the negative of other sublayer FilterConfigurations
 * @returns FilterConfiguration
 */
export const negativeFilterConfiguration = (sublayers: SublayerConfig[]): FilterConfiguration["Mapbox"] => {
  return ["!", ["any", ...sublayers.map(({ FilterConfiguration: filter }) => filter?.Mapbox || BLANK_FILTER)]];
};

export const openStreetViewUrl = (feature: Feature<LineString>) => {
  const from = feature.geometry.coordinates[0];
  const to = feature.geometry.coordinates[1];
  const direction = bearing([from[0], from[1]], [to[0], to[1]]);
  const myUrl = `https://maps.google.com/maps?q=&layer=c&cbll=${from[1]},${from[0]}&cbp=11,${direction},0,0,0`;

  window.open(myUrl, "_blank")?.focus();
};
